import React, { useState } from "react";

import { Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import { DateRange } from "store/types";

const years: string[] = [];
for (let y = new Date().getFullYear() - 1; y > 1970; y--) {
  years.push(y.toString());
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (value: DateRange) => void;
}

export const SelectYearDialog: React.FC<Props> = ({ isOpen, onClose, onSubmit }) => {
  const [year, setYear] = useState<string>();

  const handleSubmit = () => {
    if (year) {
      // Submit disabled if no year selected
      const fromDate = dayjs(new Date(year)).toISOString();
      const toDate = dayjs(new Date(year + "-12-31")).toISOString();
      onSubmit({ from: fromDate, to: toDate });
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <Stack sx={{ padding: "32px", width: "265px" }}>
        <Stack
          sx={{ borderBottom: "1px solid #dae0e2" }}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography p={0} color="#071F35" fontSize="18px">
            Select year
          </Typography>
          <IconButton sx={{ padding: "3px" }} onClick={onClose}>
            <Close sx={{ fontSize: "20px", color: "#5d7782" }} />
          </IconButton>
        </Stack>
        <DialogContent sx={{ padding: "10px 0px" }}>
          <TextField
            value={year}
            onChange={(e) => setYear(e.target.value)}
            fullWidth
            select
            label="Year"
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    maxHeight: "370px"
                  }
                }
              }
            }}
          >
            {years.map((year) => (
              <MenuItem value={year} key={year}>
                {year}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions sx={{ padding: "0" }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={!year} onClick={handleSubmit} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};
